import { useParams } from "react-router-dom"
import { useRoute } from "@hydrologiq/shared/providers/helpers/useRoute"
import { Section, SectionRoot } from "@hydrologiq/shared/chakra/custom/Section"
import CustomerSiteFigures from "../components/sites/CustomerSiteFigures"
import CustomerSiteSystemsTable from "../components/sites/CustomerSiteSystemsTable"
import AssetsTable from "@hydrologiq/shared/asset/AssetsTable"
import { useCustomerError, useCustomerLoading, useCustomerSite } from "../providers/helpers/useCustomer"
import CustomerSiteInformation from "../components/sites/CustomerSiteInformation"
import CustomerSiteAdmin from "../components/sites/CustomerSiteAdmin"
import { useGetProfile } from "@hydrologiq/shared/providers/helpers/useProfile"
import { TenantProfile } from "@hydrologiq/gql-experience/graphql"
import { Tabs } from "@chakra-ui/react"

function CustomerSite() {
  let route = useRoute()
  route = route.endsWith("/") ? route : `${route}/`
  const { customerId = "", siteId = "" } = useParams()
  const loading = useCustomerLoading()
  const customerSite = useCustomerSite()
  const error = useCustomerError()
  const profile = useGetProfile()
  const isRentalProfile = profile === TenantProfile.Rental

  return (
    <SectionRoot>
      <Section>
        <CustomerSiteFigures site={customerSite} loading={loading} error={error ?? undefined} />
      </Section>

      <Tabs.Root defaultValue="assets" variant={"sectionLozenge" as any}>
        <Tabs.List>
          <Tabs.Trigger value="assets">Assets</Tabs.Trigger>
          {isRentalProfile && <Tabs.Trigger value="systems">Systems</Tabs.Trigger>}
          <Tabs.Trigger value="information">Information</Tabs.Trigger>
          <Tabs.Trigger value="admin">Admin</Tabs.Trigger>
        </Tabs.List>

        <Tabs.Content value="assets" style={{ borderTopLeftRadius: 0 }}>
          <AssetsTable customerId={customerId} siteId={siteId} external={true} />
        </Tabs.Content>

        {isRentalProfile && (
          <Tabs.Content value="systems">
            <CustomerSiteSystemsTable customerId={customerId} customerName={customerSite?.name} siteId={siteId} />
          </Tabs.Content>
        )}

        <Tabs.Content value="information">
          <CustomerSiteInformation site={customerSite} />
        </Tabs.Content>

        <Tabs.Content value="admin">
          <CustomerSiteAdmin site={siteId} customer={customerId} />
        </Tabs.Content>
      </Tabs.Root>
    </SectionRoot>
  )
}

export default CustomerSite
